import React, { useEffect, useState } from 'react'
import AboutUs from './editcontext/AboutUs'
import BusinessCategory from './editcontext/BusinessCategory'
import CompanyInfo from './editcontext/CompanyInfo'
import CompanyOverview from './editcontext/CompanyOverview'
import ConversationGoal from './editcontext/ConversationGoal'
import YourFaqs from './editcontext/YourFaqs'
import { useSelector } from 'react-redux'
import { color } from 'framer-motion'

const EditContextai = (props) => {

    const [confusedButtonActive, setconfusedButtonActive] = useState(1);
    const [additionalFaqQuestionValue, setadditionalFaqQuestionValue] = useState('');


    const handleconfusedNextPrevious = (e, buttonIndex, type) => {
        if (type === 'next') {
            if (confusedButtonActive == 6) {
                return false;
            }
            setconfusedButtonActive(buttonIndex + 1)
        }

        if (type === 'prev') {
            if (confusedButtonActive == 1) {
                return false;
            }
            setconfusedButtonActive(buttonIndex - 1)
        }

    }

    const handleConfusedClick = (e, buttonIndex) => {
        setconfusedButtonActive(buttonIndex);
    }

    const onAddfaqQuestion = (e) => {
        setadditionalFaqQuestionValue(e);
    }
    const state = useSelector((state) => state);

    return (
        <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
            <div className="company_tabs mt-lg-4 mt-3" >
                <nav>
                    <div className="nav nav-tab border-0" id="nav-tab" role="tablist">
                        { }
                        <button
                            className={`nav-links ${confusedButtonActive === 1 && 'active'}`}
                            id="companyinfo-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#companyinfo"
                            type="button"
                            role="tab"
                            aria-controls="companyinfo"
                            aria-selected="true"
                            onClick={(e) => handleConfusedClick(e, 1)}
                            style={confusedButtonActive === 1 && 'active' && props?.isWhiteLable ? {
                                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                color: state.app.contextData?.buttonTextColor
                            } : null}
                        >
                            <i className="fa fa-info-circle" aria-hidden="true"></i> Basic info
                        </button>
                        <button
                            className={`nav-links ${confusedButtonActive === 2 && 'active'}`}
                            id="companyoverview-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#companyoverview"
                            type="button"
                            role="tab"
                            aria-controls="companyoverview"
                            aria-selected="true"
                            style={confusedButtonActive === 2 && 'active' && props?.isWhiteLable ? {
                                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                color: state.app.contextData?.buttonTextColor
                            } : null}
                            onClick={(e) => handleConfusedClick(e, 2)}
                        >
                            <i className="fa fa-briefcase"></i> Company Overview
                        </button>
                        <button
                            className={`nav-links ${(confusedButtonActive === 3) && 'active'}`}
                            id="aboutus-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#aboutus"
                            type="button"
                            role="tab"
                            aria-controls="aboutus"
                            aria-selected="false"
                            onClick={(e) => handleConfusedClick(e, 3)}
                            style={confusedButtonActive === 3 && 'active' && props?.isWhiteLable ? {
                                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                color: state.app.contextData?.buttonTextColor
                            } : null}
                        >
                            <i className="fas fa-address-card"></i> About Us
                        </button>
                        <button
                            className={`nav-links ${(confusedButtonActive === 4) && 'active'}`}
                            id="yourfaq-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#yourfaq"
                            type="button"
                            role="tab"
                            aria-controls="yourfaq"
                            aria-selected="false"
                            onClick={(e) => handleConfusedClick(e, 4)}
                            style={confusedButtonActive === 4 && 'active' && props?.isWhiteLable ? {
                                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                color: state.app.contextData?.buttonTextColor
                            } : null}
                        >
                            <i className="fa fa-question-circle" aria-hidden="true"></i> Your FAQs
                        </button>
                        <button
                            className={`nav-links ${(confusedButtonActive === 5) && 'active'}`}
                            id="conversationgoal-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#conversationgoal"
                            type="button"
                            role="tab"
                            aria-controls="conversationgoal"
                            aria-selected="false"
                            onClick={(e) => handleConfusedClick(e, 5)}
                            style={confusedButtonActive === 5 && 'active' && props?.isWhiteLable ? {
                                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                color: state.app.contextData?.buttonTextColor
                            } : null}
                        >
                            <i className="fas fa-comments"></i> Conversation Goal
                        </button>
                        <button
                            className={`nav-links ${(confusedButtonActive === 6) && 'active'}`}
                            id="businesscategory-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#businesscategory"
                            type="button"
                            role="tab"
                            aria-controls="businesscategory"
                            aria-selected="false"
                            onClick={(e) => handleConfusedClick(e, 6)}

                            style={confusedButtonActive === 6 && 'active' && props?.isWhiteLable ? {
                                backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                color: state.app.contextData?.buttonTextColor
                            } : null}
                        >
                            <i className="fa fa-exclamation-triangle"></i> Excluded Context
                        </button>
                    </div>
                </nav>

                {/* {props?.templateData?.data ? */}
                {!props?.templateData?.data ? <>
                    <div className="tab-content py-md-4" id="nav-tabContent">

                        <CompanyInfo activeTab={confusedButtonActive} />
                        <CompanyOverview activeTab={confusedButtonActive} dataUrls={props?.dataUrls} dataUrl={props?.dataUrl} />
                        <BusinessCategory activeTab={confusedButtonActive} />
                        <AboutUs activeTab={confusedButtonActive} dataUrls={props?.dataUrls}

                        />
                        <YourFaqs
                            questions={props.questions}
                            answers={props.answers}
                            activeTab={confusedButtonActive}
                            additionalFaqQuestionValue={additionalFaqQuestionValue}
                            onAddfaqQuestion={onAddfaqQuestion}
                            results={props?.results}

                        />
                        <ConversationGoal activeTab={confusedButtonActive} dataSubmit={props.dataSubmit} />


                        <div className="next-pre-btn d-flex justify-content-end mt-lg-5 mt-3 pt-md-5">
                            {confusedButtonActive != 1 &&
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary me-3"
                                    onClick={(e) => handleconfusedNextPrevious(e, confusedButtonActive, 'prev')}
                                    disabled={confusedButtonActive == 1 ? true : false}
                                >
                                    <i className="fas fa-chevron-left"></i> Previous
                                </button>
                            }
                            {confusedButtonActive != 6 &&
                                <button
                                    type="button"
                                    className="main_btns"
                                    onClick={(e) => handleconfusedNextPrevious(e, confusedButtonActive, 'next')}
                                    disabled={(confusedButtonActive == 6) ? true : false}

                                    style={props?.isWhiteLable ? {
                                        backgroundImage: `linear-gradient(45deg, ${state.app.contextData?.primaryColor}, ${state.app.contextData?.secondaryColor})`,
                                        color: state.app.contextData?.buttonTextColor
                                    } : null}

                                >
                                    Next
                                    <i className="fas fa-chevron-right" style={{ padding: 6 }}></i>
                                </button>
                            }
                        </div>
                    </div>
                </> :
                    <>

                        {props?.templateData?.data?.map(data => (
                            <div className="tab-content py-md-4" id="nav-tabContent">

                                <CompanyInfo activeTab={confusedButtonActive} data={data} />
                                <CompanyOverview activeTab={confusedButtonActive} dataUrls={props?.dataUrls} dataUrl={props?.dataUrl} data={data?.company_overview} />
                                <BusinessCategory activeTab={confusedButtonActive} />
                                <AboutUs activeTab={confusedButtonActive} dataUrls={props?.dataUrls} data={data?.about_us}

                                />
                                <YourFaqs
                                    questions={props.questions}
                                    answers={props.answers}
                                    activeTab={confusedButtonActive}
                                    additionalFaqQuestionValue={additionalFaqQuestionValue}
                                    onAddfaqQuestion={onAddfaqQuestion}
                                    results={props?.results}
                                    data={data?.your_faq}
                                />
                                <ConversationGoal activeTab={confusedButtonActive} dataSubmit={props?.dataSubmit}
                                />


                                <div className="next-pre-btn d-flex justify-content-end mt-lg-5 mt-3 pt-md-5">
                                    {confusedButtonActive != 1 &&
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary me-3"
                                            onClick={(e) => handleconfusedNextPrevious(e, confusedButtonActive, 'prev')}
                                            disabled={confusedButtonActive == 1 ? true : false}
                                        >
                                            <i className="fas fa-chevron-left"></i> Previous
                                        </button>
                                    }

                                    {confusedButtonActive != 6 &&
                                        <button
                                            type="button"
                                            className="main_btns"
                                            onClick={(e) => handleconfusedNextPrevious(e, confusedButtonActive, 'next')}
                                            disabled={(confusedButtonActive == 6) ? true : false}
                                            style={{ color: "primary" }}
                                        >
                                            Next
                                            <i className="fas fa-chevron-right"></i>
                                        </button>
                                    }
                                </div>

                            </div>
                        ))}
                    </>}

            </div>

        </div>
    )
}

export default EditContextai